<!--跟MindCollect 一樣可集成多個心智圖，只是是for一般心智圖，不具任務座號之設置，稱之為mindCollectNormal-->
<template>
    <div class="mindcollect-normal-container">

        <div class="nav-menu" v-show="showAvatarMenu">
            <div class="nav-title">{{ profile.name }}</div>
            <div class="nav-title" v-show="isCollectCreator">{{ $t("mindmap.fluidRelayUsage") }}{{ currentOpenFRUsage
                }}/{{ maxOpenFRUsage }}</div>
            <div class="nav-item" @click="logout">{{ $t("mindmap.logout") }}</div>
        </div>


        <div class="view-btn search-btn-mid" :class="{ 'search-btn-mid-down': !isLogin }" @click="openSearchBox()">
            <svg-icon icon-class="search" class="search-icon" />
        </div>

        <div class="search-box" v-show="showSearchBox">
            <!--搜尋-->
            <div class="search-wrap">
                <div class="back-btn" @click="closeSearchBox()">
                    <svg-icon icon-class="arrow-pre" />
                </div>

                <label class="search-bar">
                    <input :placeholder="$t('mindmap.mindmapHome.search')" v-model="search" />
                    <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                        <svg-icon icon-class="close" />
                    </div>
                    <button type="submit" class="search-btn" @click="searchMindMaps()" :disabled="search.length == 0">
                        <svg-icon icon-class="search" class="search-icon" />
                    </button>
                </label>
            </div>
            <!--搜尋End-->
        </div>
        <div class="flex-bar">
            <div class="left">
                <div class="title"><svg-icon iconClass="hi-mind"></svg-icon><span class="title-text">{{
            $t("mindmap.productName") }}</span></div>
            </div>
            <div class="right">
                <div v-if="!isLogin" @click="loginTMID()" class="controls profile-btn">
                    <svg-icon iconClass="profile" class="profile-icon" />
                </div>

                <div class="avatar-wrap" v-if="isLogin" @click="showAvatarMenu = !showAvatarMenu"><img class="avatar"
                        :src="profile.picture" alt="" /></div>
            </div>
        </div>

        <!-- {{ mindcollectName }}
        <div @click="createMindMap()">testCreateMindMap</div>
         -->

        <!-- 表格視圖 -->
        <div class="mindmap-list" v-show="currentView == 'list'">
            <div class="top-flex" v-show="!showSearchBox">
                <div class="left">
                    <!-- 根層標題 -->
                    <div class="title" v-if="!currentSubFolderId">
                        <span class="home-link" v-if="isCollectCreator" @click="goHome()"><svg-icon icon-class="arrow-pre" /></span>
                        <svg-icon icon-class="folder" class="folder-icon" />
                        <span class="title-text" @click="openCollectShareSetting()">{{ mindcollectName }}</span>
                    </div>
                    <!-- 子資料夾麵包屑 -->
                    <div class="title" v-else>
                        <span class="home-link" @click="exitSubFolder()"><svg-icon icon-class="arrow-pre" /></span>
                        <svg-icon icon-class="folder" class="folder-icon" />
                        <span class="title-text breadcrumb-root" @click="exitSubFolder()">{{ mindcollectName }}</span>
                        <span class="breadcrumb-sep"> / </span>
                        <svg-icon icon-class="folder" class="folder-icon" />
                        <span class="title-text">{{ currentSubFolderName }}</span>
                    </div>
                </div>
                <div class="right">
                    <!-- 根層：完整工具列 -->
                    <template v-if="!currentSubFolderId">
                        <div @click="openCreateFolderDialog()" class="temp-btn folder-create-btn" v-show="isCollectCreator">+
                            {{ $t("mindmap.mindmapHome.mindCollectNormal.createTitleSetting") }}</div>
                        <div @click="createMindMap()" class="temp-btn" v-show="isCollectCreator">+
                            {{ $t("mindmap.mindmapHome.mindCollectNormal.createMindMap") }}</div>
                        <!--搜尋-->
                        <div class="search-wrap">
                            <label class="search-bar">
                                <input :placeholder="$t('mindmap.mindCollectPage.searchTopic')" v-model="search" />
                                <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                                    <svg-icon icon-class="close" />
                                </div>
                                <button type="submit" class="search-btn" @click="searchMindMaps()" :disabled="search.length == 0">
                                    <svg-icon icon-class="search" class="search-icon" />
                                </button>
                            </label>
                        </div>
                        <div class="view-btn" :class="{ 'active-btn': currentView == 'list' }" @click="setView('list')">
                            <svg-icon icon-class="list" />
                        </div>
                        <div class="view-btn" :class="{ 'active-btn': currentView == 'grid' }" @click="setView('grid')">
                            <svg-icon icon-class="grid" />
                        </div>
                        <div class="temp-btn share-btn" v-show="isLogin && isCollectCreator" @click="openCollectShareSetting()">
                            <svg-icon icon-class="link" class="link-icon" />{{ $t('mindmap.mindmapHome.mindCollect.share') }}
                        </div>
                    </template>
                    <!-- 子資料夾內：新增心智圖 + 搜尋 + list/grid 切換 -->
                    <template v-else>
                        <div @click="createMindMap()" class="temp-btn" v-show="isCollectCreator">+
                            {{ $t("mindmap.mindmapHome.mindCollectNormal.createMindMap") }}</div>
                        <div class="search-wrap">
                            <label class="search-bar">
                                <input :placeholder="$t('mindmap.mindCollectPage.searchTopic')" v-model="search" />
                                <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                                    <svg-icon icon-class="close" />
                                </div>
                                <button type="submit" class="search-btn" @click="searchMindMaps()" :disabled="search.length == 0">
                                    <svg-icon icon-class="search" class="search-icon" />
                                </button>
                            </label>
                        </div>
                        <div class="view-btn" :class="{ 'active-btn': currentView == 'list' }" @click="setView('list')">
                            <svg-icon icon-class="list" />
                        </div>
                        <div class="view-btn" :class="{ 'active-btn': currentView == 'grid' }" @click="setView('grid')">
                            <svg-icon icon-class="grid" />
                        </div>
                    </template>
                </div>
            </div>
            <div class="list-wrap">
                <table v-if="displayedSubFolderList.length > 0 || displayedMindmapList.length > 0">
                    <thead>
                        <tr>
                            <th></th>
                            <th @click="getMyMindMapListBySort('mindmapName')">
                                {{ $t("mindmap.mindmapHome.mindmapName") }}<span
                                    v-show="currentSortField == 'mindmapName'">{{ currentSortOrder == 'asc' ?
            '↓' :
            '↑' }}</span></th>
                            <th @click="getMyMindMapListBySort('openCowork')">
                                {{ $t("mindmap.mindmapHome.share") }}<span v-show="currentSortField == 'openCowork'">{{
            currentSortOrder == 'asc' ? '↓'
                :
                '↑' }}</span></th>
                            <th @click="getMyMindMapListBySort('updateTime')">
                                {{ $t("mindmap.mindmapHome.updateTime") }}<span
                                    v-show="currentSortField == 'updateTime'">{{ currentSortOrder == 'asc' ? '↓'
            :
            '↑' }}</span></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- 子資料夾列（根層才顯示） -->
                        <tr v-for="folder in displayedSubFolderList" :key="'folder-' + folder.id"
                            class="subfolder-row" @click="enterSubFolder(folder)">
                            <td>
                                <div v-show="isLogin && isCollectCreator" class="more-btn"
                                    @click.stop="openFolderActionMenu(folder, $event)">
                                    <svg-icon iconClass="more"></svg-icon>
                                </div>
                            </td>
                            <td>
                                <svg-icon icon-class="folder" class="folder-icon" />
                                {{ folder.folderName }}
                            </td>
                            <td></td>
                            <td>{{ getTime(folder.createTime) }}</td>
                            <td>
                                <div v-show="isLogin && isCollectCreator" class="more-btn"
                                    @click.stop="openFolderActionMenu(folder, $event)">
                                    <svg-icon iconClass="more"></svg-icon>
                                </div>
                            </td>
                        </tr>
                        <!-- 心智圖列 -->
                        <tr v-for="mindmap in displayedMindmapList" :key="mindmap.id">
                            <td>
                                <div v-show="isLogin && isCollectCreator" class="more-btn"
                                    @click="openActionMenu(mindmap, $event)"><svg-icon iconClass="more"></svg-icon>
                                </div>
                            </td>
                            <td @click="clickMindItem(mindmap)">
                                <span v-show="mindmap.pk == 'MindMap'">{{ mindmap.mindmapName }} </span>
                                <span v-show="mindmap.pk == 'MindCollect'">
                                    <svg-icon v-show="mindmap.collectType == 'task'" class="task-icon"
                                        iconClass="task"></svg-icon>
                                    <svg-icon v-show="mindmap.collectType == 'normal'" class="folder-icon"
                                        iconClass="folder"></svg-icon>
                                    {{ mindmap.mindCollectName || mindmap.mindmapName }} </span>
                            </td>
                            <td>
                                <span v-show="mindmap.pk == 'MindCollect'" class="coworkmode-text"
                                    @click="openMindCollectSetting(mindmap)">
                                    <span v-show="!mindmap.allowViewOthers">
                                        <svg-icon class="close-eye-icon" iconClass="close-eye"></svg-icon>
                                        <span class="coworkmode-note-text">{{
            $t("mindmap.mindmapHome.coworkModeNoteText.closeView")
        }}</span>
                                    </span>
                                    <span v-show="mindmap.allowViewOthers">
                                        <svg-icon iconClass="eye"></svg-icon>
                                        <span class="coworkmode-note-text">{{
            $t("mindmap.mindmapHome.coworkModeNoteText.view")
        }}</span>
                                    </span>
                                </span>
                                <span v-show="mindmap.openCowork" class="coworkmode-text"
                                    @click="openShareLinkBox(mindmap)">
                                    <span v-show="mindmap.coworkMode == 'view'">
                                        <svg-icon iconClass="eye"></svg-icon>
                                        <span class="coworkmode-note-text">{{
            $t("mindmap.mindmapHome.coworkModeNoteText.view")
        }}</span>
                                    </span>
                                    <span v-show="mindmap.coworkMode == 'edit'">
                                        <svg-icon iconClass="pencil-alt"></svg-icon>
                                        <span class="coworkmode-note-text">{{
            $t("mindmap.mindmapHome.coworkModeNoteText.edit")
        }}</span>
                                    </span>
                                </span>
                            </td>
                            <td>{{ getTime(mindmap.updateTime) }}</td>
                            <td>
                                <div v-show="isLogin && isCollectCreator" class="more-btn"
                                    @click="openActionMenu(mindmap, $event)"><svg-icon iconClass="more"></svg-icon>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-md mt-5 font-bold ml-5" v-else>
                    {{ $t("mindmap.mindmapHome.noData") }}
                </div>
            </div>

        </div>

        <!--gridView，部分樣式沿用教師上傳教材網Taiwind-->
        <div class="mindmap-grid" v-show="currentView == 'grid'">
            <div class="top-flex" v-show="!showSearchBox">
                <div class="left">
                    <!-- 根層標題 -->
                    <div class="title" v-if="!currentSubFolderId">
                        <span class="home-link" v-if="isCollectCreator" @click="goHome()"><svg-icon icon-class="arrow-pre" /></span>
                        <svg-icon icon-class="folder" class="folder-icon" />
                        <span class="title-text" @click="openCollectShareSetting()">{{ mindcollectName }}</span>
                    </div>
                    <!-- 子資料夾麵包屑 -->
                    <div class="title" v-else>
                        <span class="home-link" @click="exitSubFolder()"><svg-icon icon-class="arrow-pre" /></span>
                        <svg-icon icon-class="folder" class="folder-icon" />
                        <span class="title-text breadcrumb-root" @click="exitSubFolder()">{{ mindcollectName }}</span>
                        <span class="breadcrumb-sep"> / </span>
                        <svg-icon icon-class="folder" class="folder-icon" />
                        <span class="title-text">{{ currentSubFolderName }}</span>
                    </div>
                </div>
                <div class="right">
                    <!-- 根層：完整工具列 -->
                    <template v-if="!currentSubFolderId">
                        <div @click="openCreateFolderDialog()" class="temp-btn folder-create-btn" v-show="isCollectCreator">+
                            {{ $t("mindmap.mindmapHome.mindCollectNormal.createTitleSetting") }}</div>
                        <div @click="createMindMap()" class="temp-btn" v-show="isCollectCreator">+
                            {{ $t("mindmap.mindmapHome.mindCollectNormal.createMindMap") }}</div>
                        <!--搜尋-->
                        <div class="search-wrap">
                            <label class="search-bar">
                                <input :placeholder="$t('mindmap.mindCollectPage.searchTopic')" v-model="search" />
                                <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                                    <svg-icon icon-class="close" />
                                </div>
                                <button type="submit" class="search-btn" @click="searchMindMaps()" :disabled="search.length == 0">
                                    <svg-icon icon-class="search" class="search-icon" />
                                </button>
                            </label>
                        </div>
                        <div class="view-btn" :class="{ 'active-btn': currentView == 'list' }" @click="setView('list')">
                            <svg-icon icon-class="list" />
                        </div>
                        <div class="view-btn" :class="{ 'active-btn': currentView == 'grid' }" @click="setView('grid')">
                            <svg-icon icon-class="grid" />
                        </div>
                        <div class="temp-btn share-btn" v-show="isLogin && isCollectCreator" @click="openCollectShareSetting()">
                            <svg-icon icon-class="link" class="link-icon" />{{ $t('mindmap.mindmapHome.mindCollect.share') }}
                        </div>
                    </template>
                    <!-- 子資料夾內：新增心智圖 + 搜尋 + list/grid 切換 -->
                    <template v-else>
                        <div @click="createMindMap()" class="temp-btn" v-show="isCollectCreator">+
                            {{ $t("mindmap.mindmapHome.mindCollectNormal.createMindMap") }}</div>
                        <div class="search-wrap">
                            <label class="search-bar">
                                <input :placeholder="$t('mindmap.mindCollectPage.searchTopic')" v-model="search" />
                                <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                                    <svg-icon icon-class="close" />
                                </div>
                                <button type="submit" class="search-btn" @click="searchMindMaps()" :disabled="search.length == 0">
                                    <svg-icon icon-class="search" class="search-icon" />
                                </button>
                            </label>
                        </div>
                        <div class="view-btn" :class="{ 'active-btn': currentView == 'list' }" @click="setView('list')">
                            <svg-icon icon-class="list" />
                        </div>
                        <div class="view-btn" :class="{ 'active-btn': currentView == 'grid' }" @click="setView('grid')">
                            <svg-icon icon-class="grid" />
                        </div>
                    </template>
                </div>
            </div>
            <div class="mindmapcard-wrap" v-if="displayedSubFolderList.length > 0 || displayedMindmapList.length > 0">
                <!-- 子資料夾卡片（根層才顯示） -->
                <div class="card-item subfolder-card" v-for="folder in displayedSubFolderList" :key="'folder-' + folder.id"
                    @click="enterSubFolder(folder)">
                    <div class="collect-top">
                        <svg-icon icon-class="folder" class="folder-icon" />
                    </div>
                    <div class="card-textwrap">
                        <h5>{{ folder.folderName }}</h5>
                        <p class="update-time">{{ getTime(folder.createTime) }}</p>
                    </div>
                    <div v-show="isLogin && isCollectCreator" class="more-btn"
                        @click.stop="openFolderActionMenu(folder, $event)">
                        <svg-icon icon-class="more" />
                    </div>
                </div>
                <!-- 心智圖卡片 -->
                <div class="card-item" v-for="mindmap in displayedMindmapList" :key="mindmap.id">
                    <div class="img-top" @click="clickMindItem(mindmap)" v-show="mindmap.pk == 'MindMap'"
                        v-lazy-background="getMindMapImgUrl(mindmap)" />
                    <div class="collect-top" @click="clickMindItem(mindmap)" v-show="mindmap.pk == 'MindCollect'">
                        <svg-icon v-show="mindmap.collectType == 'task'" class="task-icon" iconClass="task"></svg-icon>
                        <svg-icon v-show="mindmap.collectType == 'normal'" class="folder-icon"
                            iconClass="folder"></svg-icon>
                        <!-- <svg-icon v-show="!mindmap.openSubmit" class="forbidden-icon" iconClass="forbidden" /> -->
                    </div>

                    <div class="card-textwrap">
                        <h5 @click="clickMindItem(mindmap)">{{ mindmap.pk == 'MindMap' ? mindmap.mindmapName :
            mindmap.mindCollectName }}</h5>
                        <p class="update-time">{{ getTime(mindmap.updateTime) }}</p>
                    </div>
                    <div v-show="isLogin&&isCollectCreator" class="more-btn" @click="openActionMenu(mindmap, $event)">
                        <svg-icon icon-class="more" />
                    </div>
                    <p class="share" v-show="mindmap.openCowork">
                        <svg-icon v-show="mindmap.coworkMode == 'view'" iconClass="eye"></svg-icon><span
                            class="coworkmode-note-text" v-show="mindmap.coworkMode == 'view'">{{
            $t("mindmap.mindmapHome.coworkModeNoteText.view") }}</span>
                        <svg-icon v-show="mindmap.coworkMode == 'edit'" iconClass="pencil-alt"></svg-icon><span
                            class="coworkmode-note-text" v-show="mindmap.coworkMode == 'edit'">{{
            $t("mindmap.mindmapHome.coworkModeNoteText.edit") }}</span>
                    </p>
                    <p class="share" v-show="mindmap.pk == 'MindCollect' && mindmap.collectType == 'task'">
                        <svg-icon v-show="!mindmap.allowViewOthers" class="close-eye-icon"
                            iconClass="close-eye"></svg-icon><span class="coworkmode-note-text"
                            v-show="!mindmap.allowViewOthers">{{
            $t("mindmap.mindmapHome.coworkModeNoteText.task") }}</span>
                        <svg-icon v-show="mindmap.allowViewOthers" iconClass="eye"></svg-icon><span
                            class="coworkmode-note-text" v-show="mindmap.allowViewOthers">{{
            $t("mindmap.mindmapHome.coworkModeNoteText.task") }}</span>
                    </p>
                    <p class="share" v-show="mindmap.pk == 'MindCollect' && mindmap.collectType == 'normal'">
                        <svg-icon iconClass="eye"></svg-icon><span class="coworkmode-note-text">{{
            $t("mindmap.mindmapHome.coworkModeNoteText.view") }}</span>
                    </p>
                </div>
            </div>
            <div class="text-md ml-8 mt-8 font-bold" v-else>
                {{ $t("mindmap.mindmapHome.noData") }}
            </div>
        </div>

        <!-- 子資料夾操作選單 -->
        <div class="actions" v-show="showFolderActionMenu"
            :style="{ left: folderActionMenuPos.x + 'px', top: folderActionMenuPos.y + 'px' }">
            <div class="action-item" @click="openRenameFolderDialog()">{{ $t("mindmap.mindmapHome.rename") }}</div>
            <div class="action-item" @click="openDeleteFolderConfirm()">{{ $t("mindmap.mindmapHome.delete") }}</div>
        </div>

        <!-- 操作選單 -->
        <div class="actions" v-show="showActionMenu"
            :style="{ left: actionMenuPos.x + 'px', top: actionMenuPos.y + 'px' }">
            <div class="action-item" @click="openShareLinkBox(currentMindMap)">{{ $t("mindmap.mindmapHome.share") }}
            </div>
            <div class="action-item" @click="openComfirmDelete(currentMindMap)">{{ $t("mindmap.mindmapHome.delete") }}
            </div>
            <div class="action-item" @click="renameMindMap()">{{ $t("mindmap.mindmapHome.rename") }}</div>
            <div class="action-item" @click="openDetailInfo()">{{ $t("mindmap.mindmapHome.detailInfo") }}</div>
            <div class="action-item" @click="copyMindMap(currentMindMap)">{{ $t("mindmap.mindmapHome.copy") }}</div>
            <div class="action-item" v-show="!currentSubFolderId && subFolderList.length > 0"
                @click="openMoveToFolderDialog()">{{ $t("mindmap.mindmapHome.moveToFolder") }}</div>
            <div class="action-item" @click="confirmMoveOutFolder(currentMindMap)">
                {{ $t("mindmap.mindmapHome.moveOutFolder") }}</div>
        </div>

        <!-- 移入資料夾 Dialog -->
        <div v-show="showMoveToFolderDialog" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"><svg-icon iconClass="close" @click="closeMoveToFolderDialog()"></svg-icon></div>
                <div class="shareCard-title">{{ currentMindMap.mindmapName }}</div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.moveToFolder") }}</div>
                <div class="shareCard-content">
                    <div class="folder-list">
                        <div v-if="subFolderList.length === 0" class="no-folder">{{ $t("mindmap.mindmapHome.noFolder") }}</div>
                        <div v-else v-for="folder in subFolderList" :key="folder.id"
                            class="folder-item" :class="{ 'folder-selected': selectedSubFolderId === folder.id }"
                            @click="selectSubFolder(folder)">
                            <svg-icon icon-class="folder" class="folder-icon" />
                            <span class="folder-name">{{ folder.folderName }}</span>
                        </div>
                    </div>
                </div>
                <div class="btn-wrap">
                    <div class="temp-btn" v-show="selectedSubFolderId" @click="confirmMoveToFolder()">{{ $t("mindmap.確定") }}</div>
                    <div class="temp-btn gray-btn" @click="closeMoveToFolderDialog()">{{ $t("mindmap.取消") }}</div>
                </div>
            </div>
        </div>

        <div v-show="showComfirmDelete" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeComfirmDelete()"></svg-icon></div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.confirmDelete") }}{{ currentMindMap.mindmapName }}
                </div>
                <div>{{ $t("mindmap.mindmapHome.comfirmDelete") }}</div>
                <div class="temp-btn danger-btn" @click="deleteMindMap(currentMindMap)">{{ $t("mindmap.確定") }}</div>
                <div class="temp-btn gray-btn" @click="closeComfirmDelete()">{{ $t("mindmap.取消") }}</div>
            </div>
        </div>


        <!-- 分享鏈接框 -->
        <div v-show="showShareLinkBox && !showQRCodeCard" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeShareLinkBox()"></svg-icon></div>
                <div class="shareCard-title">{{ currentMindMap.mindmapName }}</div>

                <div v-show="currentMindMap.openCowork && currentMindMapURL !== ''" class="url-wrap"><span
                        class="url-title">URL：</span>{{ shortURLHost }}<span class="short-url">{{
            currentMindMapURL }}</span>
                    <span class="copy-btn" @click="copyShortUrl()"><svg-icon icon-class="copy" /></span>
                    <span class="copy-btn" @click="openQRCode(shortURLHost + currentMindMapURL, currentMindMapURL)"><svg-icon icon-class="qrcode-new" /></span>
                </div>
                <div class="cowork-mode">
                    <div class="cowork-mode-title">{{ $t("mindmap.mindmapHome.haveLinkCanDo") }}</div>
                    <SelectMenu :category="coworkModeCate"
                        :defaultSelect="$t('mindmap.mindmapHome.coworkModeNoteText.viewLongVer')" ref="coworkModeSelect"
                        class="cowork-mode-select" />
                    <div v-show="currentMindMap.openCowork && showSaveCoworkBtn" class="save-btn"
                        @click="saveCoworkMode()">
                        {{ $t("mindmap.mindmapHome.save") }}</div>
                    <div v-show="currentMindMap.openCowork" class="save-btn gray-btn" @click="closeOpenCowork()">
                        {{ $t("mindmap.mindmapHome.closeShare") }}
                    </div>
                    <div v-show="!currentMindMap.openCowork" @click="setOpenCowork()" class="save-btn">
                        {{ $t("mindmap.mindmapHome.publishShare") }}</div>
                </div>
            </div>
        </div>
        <!-- 重新命名框 -->
        <div v-show="showRenameBox" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeRenameBox()"></svg-icon></div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.renameFile") }}</div>

                <div class="rename-wrap">
                    <label class="rename-bar">
                        <input :placeholder="currentMindMap.mindmapName" v-model="renameVal" maxlength="20" />
                        <div class="delete-btn" v-show="renameVal.length !== 0" @click="resetRename()">
                            <svg-icon icon-class="close" />
                        </div>
                    </label>
                </div>

                <div v-show="renameVal.length !== 0 && renameVal !== currentMindMap.mindmapName" class="save-btn"
                    @click="saveRename()">
                    {{ $t("mindmap.mindmapHome.save") }}</div>
            </div>
        </div>
        <!-- 詳細資料表單 -->
        <div v-show="showDetailInfo" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeDetailInfo()"></svg-icon></div>
                <div class="shareCard-title">{{ currentMindMap.mindmapName }}</div>
                <div class="detail-info">
                    <!-- {{ currentMindMap }} -->
                    <div v-if="currentMindMap.mindmapCreator">{{ $t("mindmap.mindmapHome.mindmapCreator") }}：{{
            currentMindMap.mindmapCreator.name }}</div>
                    <div v-if="currentMindMap.mindmapCreator">{{ $t("mindmap.mindmapHome.createTime") }}：{{
            getTime(currentMindMap.createTime) }}</div>
                    <div v-if="currentMindMap.mindmapEditor">{{ $t("mindmap.mindmapHome.mindmapEditor") }}：{{
                        currentMindMap.mindmapEditor.name }}</div>
                    <div v-if="currentMindMap.mindmapEditor">{{$t("mindmap.mindmapHome.updateTime")}}：{{
                        getTime(currentMindMap.updateTime) }}</div>
                    <div>{{$t("mindmap.mindmapHome.shareShort")}}：{{ currentMindMap.openCowork ?
                        $t("mindmap.mindmapHome.true") : $t("mindmap.mindmapHome.false") }}</div>
                    <div v-if="currentMindMap.openCowork">{{$t("mindmap.mindmapHome.coworkMode")}}：{{
                        currentMindMap.coworkMode? $t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") :
                        $t("mindmap.mindmapHome.coworkModeNoteText.editLongVer") }}</div>
                </div>
            </div>
        </div>

        <!-- 資料夾設定窗格 -->
        <div v-show="showCollectShareSetting && !showQRCodeCard" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn">
                    <svg-icon iconClass="close" @click="confirmToUpdateMindCollectNormal()"></svg-icon>
                </div>
                <div class="shareCard-title">{{ $t('mindmap.mindmapHome.mindCollectNormal.updateSetting') }}</div>
                <div class="shareCard-content">
                    <div class="rename-wrap">
                        <label class="rename-bar">
                            <input :placeholder="mindcollectName" v-model="renameMindCollectVal" maxlength="20" />
                            <div class="delete-btn" v-show="renameMindCollectVal.length !== 0" @click="resetMindCollectName()">
                                <svg-icon icon-class="close" />
                            </div>
                        </label>
                    </div>
                </div>
                <div class="url-wrap url-wrap-small">
                    <span class="url-title">URL：</span>{{ shortURLHost }}<span class="short-url">{{ currentMindCollectURL }}</span>
                    <span class="copy-btn" @click="copyShortUrl()">
                        <svg-icon icon-class="copy" />
                    </span>
                    <span class="copy-btn" @click="openQRCode(shortURLHost + currentMindCollectURL, currentMindCollectURL)"><svg-icon icon-class="qrcode-new" /></span>
                </div>
            </div>
        </div>

        <!-- 新增子資料夾 Dialog -->
        <div v-show="showCreateFolderDialog" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"><svg-icon iconClass="close" @click="closeCreateFolderDialog()"></svg-icon></div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.mindCollectNormal.createTitleSetting") }}</div>
                <div class="rename-wrap">
                    <label class="rename-bar">
                        <input :placeholder="$t('mindmap.mindmapHome.mindCollectNormal.defaultName')"
                            v-model="newFolderName" maxlength="20" @keyup.enter="saveCreateFolder()" />
                        <div class="delete-btn" v-show="newFolderName.length !== 0" @click="newFolderName = ''">
                            <svg-icon icon-class="close" />
                        </div>
                    </label>
                </div>
                <div v-show="newFolderName.length > 0" class="save-btn" @click="saveCreateFolder()">
                    {{ $t("mindmap.mindmapHome.save") }}
                </div>
            </div>
        </div>

        <!-- 重新命名子資料夾 Dialog -->
        <div v-show="showRenameFolderDialog" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"><svg-icon iconClass="close" @click="closeRenameFolderDialog()"></svg-icon></div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.renameFile") }}</div>
                <div class="rename-wrap">
                    <label class="rename-bar">
                        <input :placeholder="currentFolder.folderName" v-model="renameFolderVal" maxlength="20"
                            @keyup.enter="saveRenameFolder()" />
                        <div class="delete-btn" v-show="renameFolderVal.length !== 0" @click="renameFolderVal = ''">
                            <svg-icon icon-class="close" />
                        </div>
                    </label>
                </div>
                <div v-show="renameFolderVal.length > 0 && renameFolderVal !== currentFolder.folderName" class="save-btn"
                    @click="saveRenameFolder()">
                    {{ $t("mindmap.mindmapHome.save") }}
                </div>
            </div>
        </div>

        <!-- 刪除子資料夾確認 Dialog -->
        <div v-show="showDeleteFolderConfirm" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"><svg-icon iconClass="close" @click="showDeleteFolderConfirm = false"></svg-icon></div>
                <div class="shareCard-title">{{ currentFolder.folderName }}</div>
                <div>{{ $t("mindmap.mindmapHome.mindCollectNormal.confirmDeleteCollectText") }}</div>
                <div class="temp-btn danger-btn" @click="confirmDeleteFolder()">{{ $t("mindmap.確定") }}</div>
                <div class="temp-btn gray-btn" @click="showDeleteFolderConfirm = false">{{ $t("mindmap.取消") }}</div>
            </div>
        </div>

    </div>

    <!-- QR Code Dialog -->
    <QRCodeDialog v-if="showQRCodeCard" :url="qrCodeUrl" :short-code="qrCodeShortCode" :short-u-r-l-host="shortURLHost" @close="closeQRCode" />
</template>

<script setup>
/*eslint-disable*/
import SvgIcon from "@/components/SvgIcon.vue";
import SelectMenu from "@/components/SelectMenu.vue";
import { toRaw, ref, onMounted, getCurrentInstance, reactive, computed, inject, onBeforeUnmount, watch, nextTick } from "vue";
import QRCodeDialog from "@/components/QRCodeDialog.vue";
import api from "@/api";
import { jsFn } from "@/utils/jsFn";
import { SharedMap } from "fluid-framework";
import { AzureClient } from "@fluidframework/azure-client";
import { useRouter } from 'vue-router';
import jwt_decode from "jwt-decode";
import main from "@/api/main";
import confProfile from "@/api/profile";
import i18n from "../locale";
import { useQuasar } from 'quasar'
import { useMainStore } from '@/stores/mainStore';
import { useMindMapStore } from "@/stores/mindMapStore";
import { BlobServiceClient } from "@azure/storage-blob";


var serverLocation = main.getServerLocation();

let that = getCurrentInstance().proxy;

let historyUpdateInterval = null;
const router = useRouter();
const store = useMainStore();
const mindMapStore = useMindMapStore();

const $Message = inject("$Message");
const $q = useQuasar()

const enterMindHistory = reactive({});

const containerSchema = reactive({
    initialObjects: {
        mindHistory: SharedMap,
        mindData: SharedMap,
        isDeleting: SharedMap,
        coworkMode: SharedMap,
    },
});
const coworkModeSelect = ref(null);
let fluidIsDeleting = reactive({});
let fluidCoworkMode = reactive({});

let referMindMapData = reactive({});
let referFid = ref("");



const profile = reactive({
    name: "",
    teammodelId: "",
    picture: "",
});
const isLogin = ref(false);
const showSearchBox = ref(false);
const showActionMenu = ref(false);
const showShareLinkBox = ref(false);
const showAvatarMenu = ref(false);


const search = ref("");

// 開啟搜尋框
const openSearchBox = () => {
    showSearchBox.value = true;
}

// 關閉搜尋框
const closeSearchBox = () => {
    showSearchBox.value = false;
    resetSearch();
}

// 重置搜尋
const resetSearch = () => {
    search.value = "";
    if (search.value === "") {
        // 如果搜尋條件為空，則重新獲取列表
        const data = {
            cid: that.$route.query.cid,
            sortOrder: currentSortOrder.value,
            sortField: currentSortField.value,
            search: "",
        };
        api.mindmapAPI.getMindCollectById(data).then((res) => {
            mindmapList.value = res.mindmapList;
        });
    }
}
const isCollectCreator = ref(false);
const currentSortField = ref("updateTime");
const currentSortOrder = ref("desc");
const currentMindMap = ref({});
const currentMindMapURL = ref("");
const shortURLHost = ref(confProfile.shortUrlHost[serverLocation]);
const showSaveCoworkBtn = computed(() => {
    const coworkModeTextOrigin = coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit";
    return currentMindMap.value.coworkMode && currentMindMap.value.coworkMode != coworkModeTextOrigin;
});
const coworkModeCate = ref([
    i18n.global.t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer"),
    i18n.global.t("mindmap.mindmapHome.coworkModeNoteText.editLongVer")
]);

const currentOpenFRUsage = ref(0); //開放分享的fluidrelay 之計算，只要沒有開放分享就不計在用量
const maxOpenFRUsage = ref(100); //開放分享的fluidrelay 之上限  
const isReachMaxOpenFRUsage = ref(false);
const mindmapList = ref([]);
const mindCollect = ref({});
const mindcollectName = ref("");
const useTemplate = ref(false); // 新增的資料綁定
const showComfirmDelete = ref(false);
const showRenameBox = ref(false);
const showDetailInfo = ref(false);
const showCollectShareSetting = ref(false);
const renameVal = ref("");
const renameMindCollectVal = ref("");
const currentMindCollectURL = ref("");
const currentView = ref("list");

// 子資料夾狀態
const subFolderList = ref([])
const currentSubFolderId = ref(null)
const currentFolder = ref({ folderName: '' })
const showCreateFolderDialog = ref(false)
const newFolderName = ref('')
const showRenameFolderDialog = ref(false)
const renameFolderVal = ref('')
const showDeleteFolderConfirm = ref(false)
const showFolderActionMenu = ref(false)
const folderActionMenuPos = reactive({ x: 0, y: 0 })
const showMoveToFolderDialog = ref(false)
const selectedSubFolderId = ref(null)

const currentSubFolderName = computed(() => {
    if (!currentSubFolderId.value) return ''
    const folder = subFolderList.value.find(f => f.id === currentSubFolderId.value)
    return folder?.folderName || ''
})

const displayedMindmapList = computed(() => {
    if (!currentSubFolderId.value) {
        return mindmapList.value.filter(item => item.pk === 'MindCollect' || !item.subFolderId)
    }
    return mindmapList.value.filter(item => item.subFolderId === currentSubFolderId.value)
})

const displayedSubFolderList = computed(() => currentSubFolderId.value ? [] : subFolderList.value)

const actionMenuPos = reactive({
    x: 0,
    y: 0,
});
const showMindForm = ref(false); //在作業區創建mindmap ","ContentType":"raw_content","StartLine":146,"EndLine":191}

onBeforeUnmount(async () => {
    document.removeEventListener("keydown", handleGlobalKeyDown);
    document.removeEventListener("click", handleAvatarClickOutside);
    clearInterval(historyUpdateInterval);
    await saveEnterMindHistoryDB();
})

onMounted(async () => {
    // 每 5 分鐘更新一次最近點閱到後端
    historyUpdateInterval = setInterval(saveEnterMindHistoryDB, 5 * 60 * 1000);

    try {
        await initializeAuth();
    } catch (error) {
        console.error("Error fetching auth token or mind map SAS:", error);
    }
    //初始化
    $q.loading.show();
    await getMindMapSas();
    startTokenRefreshInterval(); // 啟用檢查機制

    $q.loading.hide();

    document.addEventListener("keydown", handleGlobalKeyDown);

    const url = new URL(window.location.href);
    const queryParams = new URLSearchParams(url.search);
    const code = queryParams.get("code") || "";
    if (localStorage.getItem("profile") && localStorage.getItem("access_token")) {
        isLogin.value = true;
        let localeProfile = JSON.parse(localStorage.getItem("profile"));
        profile.name = localeProfile.name;
        profile.teammodelId = localeProfile.id || localeProfile.teammodelId;
        profile.picture = localeProfile.picture;
        
        // 從 localStorage 讀取用戶視圖偏好
        const savedView = localStorage.getItem(`mindmap_view_preference_${profile.teammodelId}`);
        if (savedView) {
            currentView.value = savedView;
        }
    } else if (code) {
        isLogin.value = true;
        const res = await api.main.getToken();
        localStorage.setItem("id_token", res.id_token);
        const decoded = jwt_decode(res.id_token);
        profile.name = decoded.name;
        profile.picture = decoded.picture;
        profile.teammodelId = decoded.sub;
        localStorage.setItem("access_token", res.access_token);
        localStorage.setItem("expires_in", res.expires_in);
        localStorage.setItem("profile", JSON.stringify(profile));

        // Remove the code parameter from the URL
        const url = new URL(window.location);
        url.searchParams.delete('code');
        url.searchParams.delete('state');
        url.searchParams.delete('clientId');
        window.history.replaceState({}, document.title, url.toString());
    }

    try {
        const data = {
            cid: that.$route.query.cid,
            sortOrder: currentSortOrder.value,
            sortField: currentSortField.value,
            search: search.value,
        };

        const res = await api.mindmapAPI.getMindCollectById(data); //獲取本頁面資料
        mindmapList.value = res.mindmapList;
        subFolderList.value = res.subFolderList || []
        mindcollectName.value = res.mindCollect.mindCollectName;
        mindCollect.value = res.mindCollect;
        useTemplate.value = res.mindCollect?.useTemplate ?? false;
        currentOpenFRUsage.value = res.fluidRelayUsage;
        isReachMaxOpenFRUsage.value = currentOpenFRUsage.value >= maxOpenFRUsage.value;

        // 讀取 fid query param，進入子資料夾
        const fid = that.$route.query.fid
        if (fid) currentSubFolderId.value = fid

        console.log("MindCollect data:", res);
        document.addEventListener("click", handleAvatarClickOutside);

        // 檢查是否需要顯示設定頁面
        if (that.$route.query.showSetting === 'true') {
            // 等待一下確保數據完全載入
            setTimeout(() => {
                openCollectShareSetting();
            }, 100);
        }

        if (isLogin.value) {
            isCollectCreator.value = mindCollect.value.creator.id === (JSON.parse(localStorage.getItem("profile"))?.id || JSON.parse(localStorage.getItem("profile"))?.teammodelId);

            // 載入歷史記錄
            const storageKey = `enterMindHistory_${profile.teammodelId}`;
            const histories = JSON.parse(localStorage.getItem(storageKey) || '[]');
            Object.assign(enterMindHistory, histories);


            console.log("profile.value:", profile, "isCollectCreator.value:", isCollectCreator.value);

        }

    } catch (error) {
        console.error("Error fetching MindCollect:", error);
    }
})

const setView = async (view) => {
    currentView.value = view
    search.value = ""

    // 保存視圖偏好到 localStorage
    if (isLogin.value && profile.teammodelId) {
        localStorage.setItem(`mindmap_view_preference_${profile.teammodelId}`, view)
    }

    if (view == 'recent') return
    const data = {
        cid: that.$route.query.cid,
        sortOrder: currentSortOrder.value,
        sortField: currentSortField.value,
        search: search.value,
    };

    const res = await api.mindmapAPI.getMindCollectById(data); //獲取本頁面資料
    mindmapList.value = res.mindmapList;
    subFolderList.value = res.subFolderList || []
    mindcollectName.value = res.mindCollect.mindCollectName;
    mindCollect.value = res.mindCollect;
    useTemplate.value = res.mindCollect?.useTemplate ?? false;
    currentOpenFRUsage.value = res.fluidRelayUsage;
    isReachMaxOpenFRUsage.value = currentOpenFRUsage.value >= maxOpenFRUsage.value;


    console.log("MindCollect data:", res);
    $q.loading.hide();
}

const getMindMapImgUrl = (mindmap) => {
    try {
        if (mindMapStore.mindMapBlobsasurl && mindMapStore.mindMapBlobSas && mindmap?.snapshotUrl) {
            return 'url("' + mindMapStore.mindMapBlobsasurl + mindmap.snapshotUrl + '?' + mindMapStore.mindMapBlobSas + '")';
        } else {
            return `url("https://${location.host}/no-image.jpg")`;

        }
    } catch (err) {
        console.log(err);
    }
}

const initializeAuth = async () => {
    try {
        const res = await api.main.getTokenUnlogin();
        const exp = jwt_decode(res.auth_token);
        localStorage.setItem("auth_token", res.auth_token);
        localStorage.setItem("auth_token_expiry", exp.exp);
    } catch (error) {
        console.error("Error fetching auth token ", error);
    }
}

const getMindMapSas = async () => {
    try {
        const res = await api.mindmapAPI.getMindMapSas();
        // 提取 token 并存储到 mindMapStore
        const { token, expiresOn } = res;
        mindMapStore.setMindMapBlobSas(token); // 存储 token

        sessionStorage.setItem("mindmap_sas_expiry", expiresOn.toString());

        initMindMapBlob();
    } catch (error) {
        console.error("Error fetching MindMap SAS:", error);
        // 可以根据需要添加更多错误处理逻辑
    }
}

const initMindMapBlob = () => {
    if (mindMapStore.mindMapBlobsasurl) {
        const serviceClient = new BlobServiceClient(
            mindMapStore.mindMapBlobsasurl + "?" + mindMapStore.mindMapBlobSas
        );
        const containerClient = serviceClient.getContainerClient("");
        mindMapStore.setMindMapBlobContainerClient(containerClient);
    }
}

let tokenRefreshInterval = ref(null);

const startTokenRefreshInterval = () => {
    tokenRefreshInterval.value = setInterval(async () => {

        //檢查auth_token是否即將過期
        const authExpiry = localStorage.getItem("auth_token_expiry");
        const now = Date.now();
        const refreshThreshold = 10 * 1000; // 提前 10 秒刷新

        if (authExpiry) {
            const exp = authExpiry * 1000; // 将 exp 转换为毫秒
            if (exp - now < refreshThreshold) {
                localStorage.removeItem("auth_token");
                localStorage.removeItem("auth_token_expiry");
                // console.log("Auth Token is about to expire. Refreshing...");
                await initializeAuth();
            }
        }

        const sasExpiry = sessionStorage.getItem("mindmap_sas_expiry");

        if (sasExpiry) {
            const sasExpiryMs = Date.parse(sasExpiry); // 将 ISO 格式时间解析为时间戳（毫秒）
            // console.log("Current Time:", now, "SAS Expiry Time:", sasExpiryMs);

            if (sasExpiryMs - now < refreshThreshold) {
                console.log("SAS Token is about to expire. Refreshing...");
                await getMindMapSas();
            }
        }
    }, 60 * 1000); // 每分检查一次
}

const initializeAzureClient = async () => {
    try {
        localStorage.removeItem("cachedFluidRelayToken"); // 初始化先移除 localStorage
        const fluidConfig = await api.mindmapAPI.getFluidRelayConfig();
        let dataCenter = (serverLocation.includes("cn")) ? "china" : "global";
        const serviceConfig = {
            connection: {
                type: "remote",
                tenantId: fluidConfig[dataCenter]?.fluidRelayTenantId,
                tokenProvider: new api.MyAzTokenProvider(api.mindmapAPI.fluidTokenUrl, {
                    "idToken": "",
                    "id": profile.teammodelId,
                    "name": profile.name,
                }),
                endpoint: fluidConfig[dataCenter]?.fluidRelayEndpoint,
            },
        };
        return new AzureClient(serviceConfig);
    } catch (error) {
        console.error("初始化 AzureClient 失敗:", error);
        throw error;
    }
}


const saveEnterMindHistoryDB = async () => {
    if (!isLogin.value || !profile.teammodelId) return; // 確保已登入且有用戶 ID

    const payload = {
        fromUser: {
            id: profile.teammodelId,
            name: profile.name,
        },
        mindmapHistories: Object.values(enterMindHistory).slice(0, 12), // 限制最多 12 筆
    };

    try {
        await api.mindmapAPI.saveMindClickHistory(payload);
    } catch (error) {
        console.error("Failed to update mind click history:", error);
    }
}

const handleAvatarClickOutside = (event) => {
    if (!event.target.closest(".nav-menu") && !event.target.closest(".avatar")) {
        showAvatarMenu.value = false;
    }
};

const handleGlobalKeyDown = (event) => {
    if (event.key === "Enter" && document.activeElement.tagName === "INPUT") {
        searchMindMaps();
    }
};

const searchMindMaps = async () => {
    console.log("search:", search.value);
    const data = {
        cid: that.$route.query.cid,
        sortOrder: currentSortOrder.value,
        sortField: currentSortField.value,
        searchText: search.value,
    };
    const res = await api.mindmapAPI.getMindCollectById(data); //獲取本頁面資料
    mindmapList.value = res.mindmapList;
    mindcollectName.value = res.mindCollect.mindCollectName;
    mindCollect.value = res.mindCollect;
};

// 排序列表
const getMyMindMapListBySort = async (field) => {
    if (currentSortField.value === field) {
        currentSortOrder.value = currentSortOrder.value === "asc" ? "desc" : "asc";
    } else {
        currentSortField.value = field;
        currentSortOrder.value = "asc";
    }

    const data = {
        cid: that.$route.query.cid,
        sortOrder: currentSortOrder.value,
        sortField: currentSortField.value,
        searchText: search.value,
    };
    const res = await api.mindmapAPI.getMindCollectById(data);
    mindmapList.value = res.mindmapList;
};



// 點擊心智圖項目
const clickMindItem = (mindmap) => {
    if (mindmap.pk === 'MindMap') {
        if (!mindmap.openCowork && !isCollectCreator.value) {
            $Message.info(that.$t("mindmap.privateInfo"));
            return
        }
        else {
            router.push({
                path: '/MindMapClone',
                query: {
                    id: mindmap.id,
                    openCowork: mindmap.openCowork,
                }
            });
        }

    }
};

// 打開操作菜單
const openActionMenu = (mindmap, event) => {
    event.stopPropagation();
    currentMindMap.value = mindmap;
    showActionMenu.value = true;
    actionMenuPos.x = event.clientX - 120
    actionMenuPos.y = event.clientY - 10

    if (actionMenuPos.x < 0) actionMenuPos.x = 30

    // 點擊其他地方關閉菜單
    const closeMenu = (e) => {
        if (!e.target.closest('.action-menu') && !e.target.closest('.more-btn')) {
            showActionMenu.value = false;
            document.removeEventListener('click', closeMenu);
        }
    };
    setTimeout(() => {
        document.addEventListener('click', closeMenu);
    }, 0);
};



const openComfirmDelete = (mindmap) => {
    currentMindMap.value = mindmap;
    showComfirmDelete.value = true
}
const closeComfirmDelete = () => {
    showComfirmDelete.value = false
}

// 打開心智圖收集設置
const openMindCollectSetting = (mindmap) => {
    // 實現心智圖收集設置的邏輯
    console.log("Open mind collect setting for:", mindmap);
};

// 打開分享鏈接框
const openShareLinkBox = async (mindmap) => {
    currentMindMap.value = mindmap;
    if (currentMindMap.value.openCowork) {
        currentMindMapURL.value = currentMindMap.value.urlClipCode
    }
    //打開時先將選單設為目前db狀態
    coworkModeSelect.value.currentSelect = currentMindMap.value.coworkMode === "view" ? that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") : that.$t("mindmap.mindmapHome.coworkModeNoteText.editLongVer")
    showActionMenu.value = false
    showShareLinkBox.value = true

    localStorage.removeItem('cachedFluidRelayToken') //初始化先移除localStorage

    fluidCoworkMode = await getFluidCoworkMode(mindmap.fluidContainerId);
};

// 關閉分享鏈接框
const closeShareLinkBox = () => {
    showShareLinkBox.value = false
    setTimeout(() => {
        if (fluidContainer && typeof fluidContainer.dispose === 'function') {
            fluidContainer.dispose();
        }
    }, 200)
}

// QR Code
const showQRCodeCard = ref(false);
const qrCodeUrl = ref('');
const qrCodeShortCode = ref('');
const openQRCode = (url, shortCode) => {
    qrCodeUrl.value = url;
    qrCodeShortCode.value = shortCode;
    showQRCodeCard.value = true;
};
const closeQRCode = () => { showQRCodeCard.value = false; };

// 複製短網址
const copyShortUrl = () => {
    const url = shortURLHost.value + currentMindMapURL.value;
    const input = document.createElement('input');
    input.value = url;
    document.body.appendChild(input);
    input.select();
    document.execCommand('Copy');
    document.body.removeChild(input);
    $Message.info(that.$t("mindmap.mainMenu.alreadyCopied"));
}

// 保存協作模式
const saveCoworkMode = async () => {
    try {
        // 將設定寫回 API
        await api.mindmapAPI.updateMindMap({
            id: currentMindMap.value.id,
            mindmapEditor: {
                id: currentMindMap.value.mindmapEditor.id,
                name: currentMindMap.value.mindmapEditor.name,
            },
            coworkMode: coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
        });
        currentMindMap.value.coworkMode = coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit";

        let fluidCoworkModeData = JSON.stringify({
            "coworkMode": currentMindMap.value.coworkMode,
            "openCowork": currentMindMap.value.openCowork,
        });

        setFluidCoworkMode(fluidCoworkModeData);

        closeShareLinkBox();
        $Message.info(that.$t("mindmap.mindmapHome.saveOk"));
    } catch (error) {
        console.error("儲存失敗：", error);
    }
};

// 設置開放協作
const setOpenCowork = async () => {
    try {
        currentMindMapURL.value = "";
        const origData = `${window.location.origin}/MindMapClone?id=${currentMindMap.value.id}`;
        currentMindMap.value.openCowork = true;

        let fluidCoworkModeData = JSON.stringify({
            "coworkMode": coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
            "openCowork": true,
        });

        const data = {
            "origDataList": [{ "origData": origData }],
            "type": "mindmap",
            "useShortDigits": false,
            "isPermanent": false,
            "lang": that.$i18n.locale.toLowerCase(),
            "note": JSON.stringify({mindmapName:currentMindMap.value.mindmapName})
        };

        const res = await api.mindmapAPI.getClipCode(data);
        const clipCode = res.clipCodePairs[0].clipCode;

        // 將設定寫回API
        await api.mindmapAPI.updateMindMap({
            id: currentMindMap.value.id,
            mindmapEditor: {
                id: currentMindMap.value.mindmapEditor.id,
                name: currentMindMap.value.mindmapEditor.name,
            },
            openCowork: true,
            coworkMode: coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
            urlClipCode: clipCode
        });
        //改顯示短網址
        currentMindMapURL.value = clipCode;
        setFluidCoworkMode(fluidCoworkModeData);
    } catch (error) {
        console.error("Error setting open cowork mode:", error);
    }
};

// 關閉開放協作
const closeOpenCowork = () => { //是否要斷開後續待側
    //將設定寫回api
    api.mindmapAPI.updateMindMap({
        id: currentMindMap.value.id,
        "mindmapEditor": {
            "id": currentMindMap.value.mindmapEditor.id,
            "name": currentMindMap.value.mindmapEditor.name,
        },
        openCowork: false,
    }).then((res) => {
        console.log(res);
        currentMindMap.value.openCowork = false;

        let fluidCoworkModeData = JSON.stringify({
            "coworkMode": coworkModeSelect.value.currentSelect === that.$t("mindmap.mindmapHome.coworkModeNoteText.viewLongVer") ? "view" : "edit",
            "openCowork": false,
        });

        setFluidCoworkMode(fluidCoworkModeData);
    })
}

// 設置 Fluid 協作模式
const setFluidCoworkMode = (data) => {
    fluidCoworkMode.set("data", data);
}

// 獲取 Fluid 協作模式
const getFluidCoworkMode = async (fluidContainerId) => {
    try {
        const client = await initializeAzureClient();
        const { container } = await client.getContainer(fluidContainerId, containerSchema, "2");
        window.fluidContainer = container;
        return container.initialObjects.coworkMode;
    } catch (error) {
        console.error("獲取 Fluid 協作模式失敗:", error);
        return null;
    }
};

// 格式化時間
// 打開重新命名框
const renameMindMap = () => {
    showRenameBox.value = true;
    renameVal.value = currentMindMap.value.mindmapName;
    console.log(currentMindMap.value);
    showActionMenu.value = false;
}

// 關閉重新命名框
const closeRenameBox = () => {
    showRenameBox.value = false;
    renameVal.value = currentMindMap.value.mindmapName;
}

// 重置重新命名值
const resetRename = () => {
    renameVal.value = currentMindMap.value.mindmapName;
}

// 保存重新命名
const saveRename = async () => {
    try {
        // 將設定寫回 API
        await api.mindmapAPI.updateMindMap({
            mindmapName: renameVal.value,
            id: currentMindMap.value.id,
            mindmapEditor: {
                id: currentMindMap.value.mindmapEditor.id,
                name: currentMindMap.value.mindmapEditor.name,
            },
        });
        currentMindMap.value.mindmapName = renameVal.value;
        closeRenameBox();
        $Message.info(that.$t("mindmap.mindmapHome.saveOk"));
    } catch (error) {
        console.error("儲存失敗：", error);
    }
}

const getTime = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString();
}
// 獲取 Fluid 心智圖數據
const getFluidMindData = async (Fid) => {
    let retryCount = 0;
    const maxRetries = 3;
    const retryDelay = 2000; // 2秒

    const tryGetContainer = async () => {
        try {
            const client = await initializeAzureClient();
            // 捕捉 getContainer 操作中的異常
            const result = await client.getContainer(Fid, containerSchema, "2");
            const container = result.container;
            const fluidMindData = container.initialObjects.mindData; //存放markdown資料
            container.dispose();
            return fluidMindData;
        } catch (error) {
            console.error(`嘗試 ${retryCount + 1}/${maxRetries} 失敗:`, error);
            $Message.info(that.$t("mindmap.tryingToGetContainer"));
            if (retryCount < maxRetries - 1) {
                retryCount++;
                console.log(`等待 ${retryDelay / 1000} 秒後重試...`);
                return new Promise(resolve => setTimeout(() => resolve(tryGetContainer()), retryDelay));
            } else {
                console.error(`已重試 ${maxRetries} 次，仍然失敗`);
                $Message.error(that.$t("mindmap.cannotConnect"));
                return; // 如果無法獲取容器，直接退出
            }
        }
    };

    return tryGetContainer();
}

const deleteMindMap = async (mindmap) => {
    $q.loading.show({
        message: that.$t("mindmap.mindmapHome.deleting")
    });
    showComfirmDelete.value = false
    const containerId = mindmap.fluidContainerId

    //初始化先移除localStorage
    let container
    try {
        const client = await initializeAzureClient();

        // 捕捉 getContainer 操作中的異常
        const result = await client.getContainer(containerId, containerSchema, "2");
        container = result.container;
    } catch (error) {
        console.error(error);
        $Message.error(that.$t("mindmap.mindmapHome.cannotConnect"));
        return; // 如果無法獲取容器，直接退出
    }


    fluidIsDeleting = container.initialObjects.isDeleting; //是否處於殺除狀態
    fluidIsDeleting.set('data', true)
    //設置完就斷開
    if (container.isDirty) {
        container.once("saved", () => {
            container.dispose();
            container = null;
            localStorage.removeItem("cachedFluidRelayToken");
        });

    }
    container.on("disposed", () => {
        console.log("container已呼叫斷開!",)
    });

    try {
        await api.mindmapAPI.deleteMindMap({ id: mindmap.id });

        mindmapList.value = [];
        const data = {
            cid: that.$route.query.cid,
            sortOrder: currentSortOrder.value,
            sortField: currentSortField.value,
            search: search.value,
        };

        const res = await api.mindmapAPI.getMindCollectById(data); //獲取本頁面資料
        mindmapList.value = res.mindmapList;
        mindcollectName.value = res.mindCollect.mindCollectName;
        mindCollect.value = res.mindCollect;
        useTemplate.value = res.mindCollect?.useTemplate ?? false;
        currentOpenFRUsage.value = res.fluidRelayUsage;
        isReachMaxOpenFRUsage.value = currentOpenFRUsage.value >= maxOpenFRUsage.value;


        console.log("MindCollect data:", res);
        $q.loading.hide();
        $Message.info(that.$t("mindmap.mindmapHome.deletingOKinFront"));

    } catch (error) {
        console.error('Error deleting mindmap:', error);

    }
};


const createMindMap = async () => {
    showMindForm.value = false;

    console.log(toRaw(mindCollect.value));
    console.log(profile, "profile")


    let data = {
        "mindmapName": that.$t("mindmap.defaultMind.root"),
        "mindmapCreator": { //已創建收集區者為創建者
            "id": profile.teammodelId,
            "name": profile.name,
        },
        "mindSubCreator": {
            "id": profile.teammodelId,
            "name": profile.name,
        },
        "collectId": mindCollect.value.id,
        "collectIdType": "normal", //直接表示資料表類型回到上層目錄需要參照
        "subFolderId": currentSubFolderId.value || null,
        "mindSubCreatorEditKey": "",
        "mindmapData": "",
        "fluidContainerId": "",
        "openCowork": false,
        "coworkMode": "view", //需要匿名使用 學生會每次用匿名身份進入，無法用其他模式
    }

    try {
        $Message.info(that.$t("mindmap.mindmapHome.initialize"));
        const client = await initializeAzureClient();


        const { container } = await client.createContainer(containerSchema, "2;");
        data.fluidContainerId = await container.attach();

        fluidIsDeleting = container.initialObjects.isDeleting;
        fluidCoworkMode = container.initialObjects.coworkMode;

        let fluidMindData = container.initialObjects.mindData;


        if (useTemplate.value === true) {
            const res = await api.mindmapAPI.getMindMapByMid({
                mid: mindCollect.value.collectReferMindId
            });
            referFid.value = res.data.fluidContainerId
            referMindMapData = await getFluidMindData(referFid.value);
            console.log("獲取最新範本:", referMindMapData);

            if (referMindMapData) {
                for (const [key, value] of referMindMapData) {
                    fluidMindData.set(key, value); //全部複製
                }
            }

        } else {

            let initMindData = [
                {
                    "id": "root",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.root") + "</p>",
                    "expanded": true,
                    "isroot": true,
                    "nodeText": that.$t("mindmap.defaultMind.root"),
                    "nodeImg": "",
                    "nodeLink": "",
                    "lock": false
                },
                {
                    "id": "uuid4",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node4") + "</p>",
                    "expanded": true,
                    "parent": { "id": "root" },
                    "direction": "left",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node4"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "red",
                        "background-color": "rgb(255, 191, 215)",
                        "lock": false
                    }
                },
                {
                    "id": "uuid3",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node3") + "</p>",
                    "expanded": true,
                    "parent": { "id": "root" },
                    "direction": "left",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node3"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "#0000ff",
                        "background-color": "rgb(139, 243, 255)",
                        "lock": false
                    }
                },
                {
                    "id": "uuid1",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node1") + "</p>",
                    "expanded": true,
                    "parent": { "id": "root" },
                    "direction": "right",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node1"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "orange",
                        "background-color": "rgb(255, 238, 139)",
                        "lock": false
                    }
                },
                {
                    "id": "uuid2",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node2") + "</p>",
                    "expanded": true,
                    "parent": { "id": "root" },
                    "direction": "right",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node2"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "green",
                        "background-color": "rgb(211, 255, 139)",
                        "lock": false
                    }
                }
            ]
            initMindData.forEach((item) => {
                fluidMindData.set(item.id, JSON.stringify(item));
            })

        }

        //初始化先把isDeleting設為false
        fluidIsDeleting.set('data', false);

        fluidCoworkMode.set('data', JSON.stringify({
            "coworkMode": "edit",
            "openCowork": true,
        }));

        const res = await api.mindmapAPI.createMindMap(data);



        router.push({
            path: '/MindMapClone',
            query: {
                id: res.id,
                openCowork: res.openCowork,
            }
        });

    } catch (error) {
        console.error(error);
        $Message.error(that.$t("mindmap.mindmapHome.initializeFailed"));
    }
}



// 詳細資料功能
const openDetailInfo = () => {
    showDetailInfo.value = true
}

const closeDetailInfo = () => {
    showDetailInfo.value = false
}

const copyMindMap = async (mindmap) => {

    if (isLogin.value) {
        let data = {
            "mindmapName": mindmap.mindmapName + '(copy)',
            "mindmapCreator": {
                "id": profile.teammodelId,
                "name": profile.name
            },
            "mindSubCreator": {
                "id": profile.teammodelId,
                "name": profile.name,
            },
            "collectId": mindCollect.value.id,
            "collectIdType": "normal", //直接表示資料表類型回到上層目錄需要參照
            "mindSubCreatorEditKey": "",
            "mindmapData": "",
            "fluidContainerId": "",
            "openCowork": false,
            "coworkMode": "view", //需要匿名使用 學生會每次用匿名身份進入，無法用其他模式
        }

        try {
            const client = await initializeAzureClient();

            const { container } = await client.createContainer(containerSchema, "2;");
            data.fluidContainerId = await container.attach();

            fluidIsDeleting = container.initialObjects.isDeleting;
            fluidCoworkMode = container.initialObjects.coworkMode;

            let fluidMindData = container.initialObjects.mindData;
            const copyMindData = await getFluidMindData(mindmap.fluidContainerId);

            console.log(copyMindData, "複製的mindData")
            if (copyMindData) {
                for (const [key, value] of copyMindData) {
                    fluidMindData.set(key, value); //全部複製
                }
            }

            //初始化先把isDeleting設為false
            fluidIsDeleting.set('data', false);

            fluidCoworkMode.set('data', JSON.stringify({
                "coworkMode": "view",
                "openCowork": false,
            }));


            const res = await api.mindmapAPI.createMindMap(data);

            const origData = `${window.location.origin}/MindMapClone?id=${res.id}`;
            const dataForClip = {
                "origDataList": [{ "origData": origData }],
                "type": "mindmap",
                "useShortDigits": false,
                "isPermanent": false,
                "lang": that.$i18n.locale.toLowerCase(),
                "note": JSON.stringify({mindmapName:data.mindmapName})
            };

            const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
            const clipCode = clipRes.clipCodePairs[0].clipCode;

            await api.mindmapAPI.updateMindMap({
                id: res.id,
                mindmapEditor: {
                    id: profile.teammodelId,
                    name: profile.name,
                },
                urlClipCode: clipCode,
            });

            router.push({
                path: '/MindMapClone',
                query: {
                    id: res.id,
                    openCowork: res.openCowork,
                }
            });


        } catch (error) {
            console.error(error);
            $Message.error(that.$t("mindmap.mindmapHome.initializeFailed"));
        }
    }
}
const loginTMID = () => {
    api.main.loginTmdID();
}

const logout = () => {
    showAvatarMenu.value = false
    if (isLogin.value) {
        api.main.logout().then(async () => {

            $Message.info(that.$t("mindmap.mindmapHome.logoutOK"));
            //mountMsg("已登出 ~ ");
            //router.push("/");
            isLogin.value = false;
            store.setIsLogIn(false);
            localStorage.clear();
            sessionStorage.clear();
            router.push("/MindMapHome");
        });
    }
}

const goHome = () => {
    router.push('/mindmaphome');
}

// ===== 子資料夾功能 =====

const enterSubFolder = (folder) => {
    currentSubFolderId.value = folder.id
    router.push({ path: that.$route.path, query: { ...that.$route.query, fid: folder.id } })
}

const exitSubFolder = () => {
    currentSubFolderId.value = null
    const query = { ...that.$route.query }
    delete query.fid
    router.push({ path: that.$route.path, query })
}

// 新增資料夾
const openCreateFolderDialog = () => {
    newFolderName.value = ''
    showCreateFolderDialog.value = true
}
const closeCreateFolderDialog = () => {
    showCreateFolderDialog.value = false
    newFolderName.value = ''
}
const saveCreateFolder = async () => {
    if (!newFolderName.value.trim()) return
    try {
        const folder = await api.mindmapAPI.createSubFolder({
            collectId: mindCollect.value.id,
            folderName: newFolderName.value.trim(),
            creatorId: profile.teammodelId,
        })
        subFolderList.value.push(folder)
        closeCreateFolderDialog()
        $Message.info(that.$t("mindmap.mindmapHome.saveOk"))
    } catch (err) {
        console.error(err)
        $Message.error(that.$t("mindmap.mindmapHome.saveFail"))
    }
}

// 子資料夾操作選單
const openFolderActionMenu = (folder, event) => {
    event.stopPropagation()
    currentFolder.value = folder
    showFolderActionMenu.value = true
    folderActionMenuPos.x = event.clientX - 120
    folderActionMenuPos.y = event.clientY - 10
    if (folderActionMenuPos.x < 0) folderActionMenuPos.x = 30
    const closeMenu = (e) => {
        if (!e.target.closest('.actions') && !e.target.closest('.more-btn')) {
            showFolderActionMenu.value = false
            document.removeEventListener('click', closeMenu)
        }
    }
    setTimeout(() => document.addEventListener('click', closeMenu), 0)
}

// 重新命名子資料夾
const openRenameFolderDialog = () => {
    renameFolderVal.value = currentFolder.value.folderName
    showFolderActionMenu.value = false
    showRenameFolderDialog.value = true
}
const closeRenameFolderDialog = () => {
    showRenameFolderDialog.value = false
    renameFolderVal.value = ''
}
const saveRenameFolder = async () => {
    if (!renameFolderVal.value.trim() || renameFolderVal.value === currentFolder.value.folderName) return
    try {
        await api.mindmapAPI.renameSubFolder({
            subFolderId: currentFolder.value.id,
            folderName: renameFolderVal.value.trim(),
        })
        const target = subFolderList.value.find(f => f.id === currentFolder.value.id)
        if (target) target.folderName = renameFolderVal.value.trim()
        closeRenameFolderDialog()
        $Message.info(that.$t("mindmap.mindmapHome.saveOk"))
    } catch (err) {
        console.error(err)
        $Message.error(that.$t("mindmap.mindmapHome.saveFail"))
    }
}

// 刪除子資料夾
const openDeleteFolderConfirm = () => {
    showFolderActionMenu.value = false
    showDeleteFolderConfirm.value = true
}
const confirmDeleteFolder = async () => {
    try {
        await api.mindmapAPI.deleteSubFolder({ subFolderId: currentFolder.value.id })
        subFolderList.value = subFolderList.value.filter(f => f.id !== currentFolder.value.id)
        // 移除本地 mindmapList 中屬於該資料夾的心智圖
        mindmapList.value = mindmapList.value.filter(m => m.subFolderId !== currentFolder.value.id)
        showDeleteFolderConfirm.value = false
        $Message.info(that.$t("mindmap.mindmapHome.deletingOKinFront"))
    } catch (err) {
        console.error(err)
        $Message.error(that.$t("mindmap.mindmapHome.saveFail"))
    }
}

// 移入資料夾
const openMoveToFolderDialog = () => {
    showActionMenu.value = false
    selectedSubFolderId.value = null
    showMoveToFolderDialog.value = true
}
const closeMoveToFolderDialog = () => {
    showMoveToFolderDialog.value = false
    selectedSubFolderId.value = null
}
const selectSubFolder = (folder) => {
    selectedSubFolderId.value = folder.id
}
const confirmMoveToFolder = async () => {
    if (!selectedSubFolderId.value) return
    try {
        await api.mindmapAPI.moveMindmapToFolder({
            mindmapId: currentMindMap.value.id,
            subFolderId: selectedSubFolderId.value,
        })
        currentMindMap.value.subFolderId = selectedSubFolderId.value
        closeMoveToFolderDialog()
        $Message.info(that.$t("mindmap.mindmapHome.moveSuccess"))
    } catch (err) {
        console.error(err)
        $Message.error(that.$t("mindmap.mindmapHome.moveFail"))
    }
}

// 確認移出資料夾
const confirmMoveOutFolder = async (mindmap) => {
    try {
        if (currentSubFolderId.value) {
            // 在子資料夾內：移回根層（清除 subFolderId）
            await api.mindmapAPI.moveMindmapToFolder({
                mindmapId: mindmap.id,
                subFolderId: null,
            });
            mindmap.subFolderId = null;
        } else {
            // 在根層：移出整個收集區（清除 collectId）
            await api.mindmapAPI.updateMindMap({
                id: mindmap.id,
                mindmapEditor: {
                    id: profile.teammodelId,
                    name: profile.name,
                },
                collectId: "",
                collectIdType: "",
            });
            const data = {
                cid: that.$route.query.cid,
                sortOrder: currentSortOrder.value,
                sortField: currentSortField.value,
                search: "",
            };
            mindmapList.value = [];
            await api.mindmapAPI.getMindCollectById(data).then((res) => {
                mindmapList.value = res.mindmapList;
            });
        }

        $Message.success(that.$t("mindmap.mindmapHome.moveOutSuccess"));
        showActionMenu.value = false;
    } catch (error) {
        console.error('移出失敗:', error);
        $Message.error(that.$t("mindmap.mindmapHome.moveOutFail"));
    }
}

// 檢查簡碼有效性並自動重新生成的函數
const checkAndRefreshClipCodeIfNeeded = async (mindCollectData) => {
    if (!mindCollectData || !mindCollectData.urlClipCode) {
        return;
    }

    const now = Date.now();
    const ninetyDaysInMs = 90 * 24 * 60 * 60 * 1000; // 90天的毫秒數
    
    // 檢查是否有 urlClipCodeUpdateTime，如果沒有或超過90天，則檢查簡碼有效性
    if (!mindCollectData.urlClipCodeUpdateTime || (now - mindCollectData.urlClipCodeUpdateTime) > ninetyDaysInMs) {
        try {
            const checkData = { clipCode: mindCollectData.urlClipCode };
            await api.mindmapAPI.getOrigDataFromClipCode(checkData);
            // 簡碼仍有效，不需重新生成
        } catch (error) {
            if (error.response?.status === 404) {
                // 簡碼已失效，重新生成
                await autoRefreshClipCode(mindCollectData);
            } else {
                console.error("檢查簡碼時發生錯誤:", error);
            }
        }
    }
};

// 自動重新生成簡碼的函數
const autoRefreshClipCode = async (mindCollectData) => {
    try {
        // 獲取新的簡碼
        const currentMindMapURL = `${location.origin}/mindcollectnormal?cid=${mindCollectData.id}`;
        const dataForClip = {
            "origDataList": [{ "origData": currentMindMapURL }],
            "type": "mindmap",
            "useShortDigits": false,
            "isPermanent": false,
            "lang": that.$i18n.locale.toLowerCase(),
            "note": JSON.stringify({mindCollectName: mindCollectData.mindCollectName})
        };
        const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
        const newClipCode = clipRes.clipCodePairs[0].clipCode;

        // 更新心智圖收集的簡碼
        const updateData = {
            cid: mindCollectData.id,
            mindCollectName: mindCollectData.mindCollectName,
            editor: {
                id: mindCollectData.editor ? mindCollectData.editor.id : profile.teammodelId,
                name: mindCollectData.editor ? mindCollectData.editor.name : profile.name
            },
            collectType: "normal",
            urlClipCode: newClipCode,
        };
        await api.mindmapAPI.updateMindCollect(updateData);
        
        // 更新本地資料
        mindCollectData.urlClipCode = newClipCode;
        mindCollectData.urlClipCodeUpdateTime = Date.now();
        currentMindCollectURL.value = newClipCode;
        
        console.log("簡碼已自動更新:", newClipCode);
        
    } catch (error) {
        console.error("自動重新獲取簡碼失敗:", error);
    }
};

// 檢查是否需要顯示簡碼更新提示
const checkAndShowClipCodeUpdateNotice = (mindCollectData) => {
    if (!mindCollectData || !mindCollectData.urlClipCodeUpdateTime || !mindCollectData.createTime) {
        return;
    }

    // 檢查此 session 是否已經顯示過此 mindCollect 的提醒
    const sessionKey = `clipCodeNoticeShown_${mindCollectData.id}`;
    if (sessionStorage.getItem(sessionKey)) {
        return; // 此 session 已顯示過，不再顯示
    }

    const now = Date.now();
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000; // 7天的毫秒數
    const createTimeMs = mindCollectData.createTime * 1000; // createTime 是秒，轉換為毫秒
    const updateTime = mindCollectData.urlClipCodeUpdateTime;

    // 檢查是否是最近更新的（7天內），且不是創建時的初始簡碼
    // 使用時間差來判斷，容忍5分鐘的誤差
    const timeDiff = Math.abs(updateTime - createTimeMs);
    const fiveMinutesInMs = 5 * 60 * 1000; // 5分鐘的毫秒數

    if ((now - updateTime) <= sevenDaysInMs && timeDiff > fiveMinutesInMs) {
        $Message.warning(that.$t("mindmap.mindmapHome.clipCodeAutoUpdated"));

        // 標記此 session 已顯示過此 mindCollect 的提醒
        sessionStorage.setItem(sessionKey, 'true');
    }
};

// 開啟資料夾設定並檢查簡碼
const openCollectShareSetting = async () => {
    // 檢查並自動更新簡碼（如果超過90天且無效）
    await checkAndRefreshClipCodeIfNeeded(mindCollect.value);
    
    // 檢查並顯示簡碼更新提示（如果在7天內更新過且不是創建時間）
    checkAndShowClipCodeUpdateNotice(mindCollect.value);
    
    renameMindCollectVal.value = mindcollectName.value;
    currentMindCollectURL.value = mindCollect.value.urlClipCode || "";
    showCollectShareSetting.value = true;
}

// 關閉資料夾設定
const closeCollectShareSetting = () => {
    showCollectShareSetting.value = false;
    renameMindCollectVal.value = "";
}

// 重置名稱
const resetMindCollectName = () => {
    renameMindCollectVal.value = mindcollectName.value;
}

// 確認更新資料夾設定 (關閉時自動保存如有變更)
const confirmToUpdateMindCollectNormal = async () => {
    // 檢查是否有變更
    const hasChanges = renameMindCollectVal.value && 
                      renameMindCollectVal.value !== mindcollectName.value;
    
    if (hasChanges) {
        try {
            const data = {
                cid: that.$route.query.cid,
                mindCollectName: renameMindCollectVal.value,
                editor: {
                    id: profile.teammodelId,
                    name: profile.name,
                },
                openSubmit: mindCollect.value.openSubmit,
                allowViewOthers: mindCollect.value.allowViewOthers,
                collectType: "normal"
            };

            await api.mindmapAPI.updateMindCollect(data);
            
            // 更新本地數據
            mindcollectName.value = renameMindCollectVal.value;
            mindCollect.value.mindCollectName = mindcollectName.value;
            
            $Message.info(that.$t("mindmap.mindmapHome.saveOk"));
        } catch (error) {
            console.error("更新失敗：", error);
            $Message.error(that.$t("mindmap.mindmapHome.saveFail"));
        }
    }
    
    // 無論是否有變更都關閉窗格
    closeCollectShareSetting();
}


</script>
<style lang="less">
@import "../assets/color.less";

.mindcollect-normal-container {
    .select-btn {
        &:focus {
            --tw-ring-color: @light-color !important;
        }

        .arrow-icon-up {
            color: @light-color !important;
        }
    }
}
</style>
<style scoped lang="less">
@import "../assets/mindmapCollectNormal.less";
</style>